import { Heart, Compass, Eye, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

const reasons = [
  { icon: Compass, text: "En guide til et mere bevidst sabbatår" },
  { icon: Eye, text: "Hjælper dig med at finde retning før du vælger" },
  { icon: Sparkles, text: "Gør store valg mere overskuelige" },
  { icon: Heart, text: "Lavet med unge i tankerne — af unge" },
];

const WhySection = () => {
  const { ref, isVisible } = useScrollAnimation(0.15);

  return (
    <section className="py-20 md:py-28 section-gradient-warm" ref={ref}>
      <div className="container max-w-3xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-heading md:text-display-sm text-foreground mb-4">
            Hvorfor MySabbat?
          </h2>
          <p className="text-lg text-muted-foreground mb-12 max-w-xl mx-auto">
            Ikke bare endnu en app — men en platform der hjælper dig med at tage de rigtige skridt i dit sabbatår.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6">
          {reasons.map((reason, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: 0.15 + i * 0.1 }}
              className="flex items-start gap-4 text-left p-5 rounded-2xl glass-card"
            >
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                <reason.icon className="w-5 h-5 text-primary" />
              </div>
              <span className="text-foreground font-medium leading-snug pt-1.5">{reason.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;
